import { checkEmpty } from "./stringutil";

const useDebugFilter = false;
const debugFilter: string[] = ["Page", "getValueList", "Data.useEffect", "inputFunction", "getDBData"];
const filterEmpty = checkEmpty(debugFilter);
const debugCount = filterEmpty ? 5 : 8;
export function Debug(...arg: any) {
  if (checkDebug()) {
    let ssr = true;
    let sstStr = "";
    const funcs: string[] = [];
    const result: string[] = [];
    try {
      if (window.localStorage) {
        ssr = false;
      }
    } catch (e) {}
    try {
      const error = new Error();
      // if (!ssr) {
      //   error.stack?.split("\n").forEach((item, index) => {
      //     if (index === 2) console.warn(item);
      //   });
      // }
      const stack = error.stack?.split("\n");
      let i_src = "";
      stack?.map((item, index) => {
        if (index > 1 && index < debugCount) {
          let i_str = item.trim();
          let i_name = "";
          let i_text = "";
          if (i_str.indexOf("(") > -1) {
            i_name = i_str.substring(3, i_str.indexOf("("));
            i_str = i_str.substring(i_str.indexOf("(") + 1, i_str.length - 1);
            const i_arr = i_str.split("/");
            i_text = i_arr[i_arr.length - 1];
            i_str = (i_name && i_name.length > 0 ? i_name + " : " : "") + i_text;
            // if (ssr) {
            //   i_str = i_text;
            // } else {
            //   //i_str = `<a href="${i_str}">${i_text}</a>`;
            // }
            funcs.push(i_name.trim());
          }
          if (index == 2) {
            result.push(i_str);
            i_src = checkEmpty(i_text) ? i_str : i_text;
            // console.warn(item);
          }
        }
      });
      if (!checkEmpty(i_src)) {
        funcs.push(i_src);
      }
    } catch (e) {}
    if (
      !useDebugFilter ||
      (useDebugFilter &&
        (filterEmpty ||
          (!filterEmpty && funcs.some((item) => debugFilter.includes(item) || debugFilter.some((f) => f.indexOf(item) === 0)))))
    ) {
      if (ssr) {
        sstStr = "[ " + result.join(" > ") + " ] :";
        console.debug(sstStr, ...arg);
        // console.warn(error.stack);
      } else {
        // console.debug(error.stack);
        console.warn(funcs.join(" > "));
        console.debug(...arg);
      }
    }
  }
}
export function checkDebug() {
  return process.env.NEXT_PUBLIC_LOCAL && (process.env.NODE_ENV ?? "test") !== "production";
}
